import axios from 'axios'
import isEmpty from 'lodash-es/isEmpty'
import { logger } from '@/logger'
import { executePost } from '@/api/AxiosUtil'
import Cookies from 'js-cookie'
import { UPLOAD_COOKIE, useRootStore } from '@/stores/store'

export const login = (username, password) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/login', {
        username: username,
        password: password
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject(error.response.statusText)
      })
  })
}

export const verifyMfa = (code, rememberDevice) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/mfa', {
        code: code,
        rememberDevice: rememberDevice
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject(error.response.statusText)
      })
  })
}

export const logout = async () => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/logout')
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const getUser = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/v2/user')
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const resetPassword = (email) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/user/password-reset', {
        email: email
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const mfaRequest = () => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/mfa-request', {})
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

/* userSettings({ phone: '1212121212' }).then((resp) => {
  console.log(resp)
}) */
export const userSetting = (setting) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/user', {
        settings: setting
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const userSettings = (settings, oldPass, newPass) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/user', {
        settings: settings,
        oldpassword: oldPass,
        newpassword: newPass
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const getTheme = (theme = '') => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/v2/theme/' + theme)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const getPropositions = () => {
  return new Promise((resolve, reject) => {
    axios
      .get('/api/v2/propositions')
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const zipCode = (zip, nr) => {
  return new Promise((resolve, reject) => {
    nr = parseInt(nr)
    const regExp = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i

    if (!regExp.test(zip) || isNaN(nr) || nr < 1) {
      reject()
    } else {
      axios
        .post('/json/zip-code-check.json.php', {
          zipCode: zip,
          number: nr
        })
        .then((response) => {
          if (response.data.error) {
            reject()
          } else {
            resolve(response.data)
          }
        })
        .catch((error) => {
          logger.error(error)
          reject()
        })
    }
  })
}

export const getShop = (deliveryAddress = {}, invID = '', secure = false) => {
  return new Promise((resolve, reject) => {
    if (isEmpty(deliveryAddress)) {
      resolve({ location: { name: 'geen geldig bezorgadres' } })
    } else {
      const themeCustomer = useRootStore().theme.customFields?.themeCustomer
      axios
        .post('/json/order-shop.json.php', {
          deliveryAddress: deliveryAddress,
          customerNumber: themeCustomer ? parseInt(themeCustomer) : invID || 0,
          secure: secure
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          logger.error(error)
          reject()
        })
    }
  })
}

export const getDeliveryDates = (
  shopID = 0,
  invID = 0,
  secure = false,
  offset
) => {
  return new Promise((resolve, reject) => {
    const themeCustomer = useRootStore().theme.customFields?.themeCustomer
    axios
      .post('/json/deliverydates.json.php', {
        shopId: shopID,
        addressId: themeCustomer ? parseInt(themeCustomer) : invID,
        secure: secure,
        offsetDate: offset
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const getProjectList = (path) => {
  return new Promise((resolve, reject) => {
    axios
      .get('/json/' + path)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const getFormatString = (fString) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/formatstring.json.php', { formatString: fString })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject()
      })
  })
}

export const selectFileStoreFiles = (sessionId, fileIds) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/v3/secure/file-store-copy`, {
        sessionId: sessionId,
        fileIds: fileIds
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        reject(logger.error(error.message))
      })
  })
}

export const selectOrderFiles = (orderFilesObj) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/file-select.json.php', {
        fileNames: orderFilesObj.filenames,
        orderId: orderFilesObj.orderId
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const signUp = (user) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/sign-up.json.php', user)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const checkRedirect = (email) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/user/check-redirect', { email: email })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const signUp2 = (user) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/user/signup', user)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const fileShare = (mail) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/file-share.json.php', mail)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const shareUploads = (command) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/upload/share-files', command)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error.response.data.message)
        reject(error.response.data.message)
      })
  })
}

export const updatePassword = (user = '', id = '', password) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v3/user/update-password', {
        email: user,
        id: id,
        password: password
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const sendMail = (contact) => {
  if ('email' in contact.userInfo && contact.userInfo.email === '') {
    delete contact.userInfo.email
  }
  return new Promise((resolve, reject) => {
    axios
      .post('/json/send-contact-form.json.php', contact)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

export const log = (message) => {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/logger', message)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        console.error(error)
        reject()
      })
  })
}

export const mergeUpload = (
  sessionId,
  identifier,
  filename,
  relativePath,
  totalChunks,
  unzipOnUpload,
  detectColourPages,
  uploadFileType
) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/v3/upload/${sessionId}`, {
        identifier,
        filename,
        relativePath,
        totalChunks,
        unpackZips: unzipOnUpload,
        detectColourPages,
        uploadFileType
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        console.log(error)
        reject(error.response.data)
      })
  })
}

export const getFilePrintSpecs = (sessionId, fileUid) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/v3/upload/${sessionId}/${fileUid}/print-specs`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        console.error(error)
        reject()
      })
  })
}

export const validateEmail = (hash) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/v3/user/validate?k=${hash}`)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        console.error(error)
        reject()
      })
  })
}

export const saveDefaultProject = (projectId) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/v3/user/default-project/${projectId}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        reject()
      })
  })
}

export const saveOrder = (model) => {
  // take out the trash first
  delete model.orderType
  delete model.userId
  delete model.themeID
  delete model.mainThemeName

  model.sessionId = Cookies.get(UPLOAD_COOKIE)

  return executePost('/api/v2/orders/combi-order', model)
}
